import React, { useEffect, useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import 'whatwg-fetch';
import { useSecurity } from '../Security/security';
import LoginForm from './LoginForm';
import MultiFactorAuthentication from './MultiFactorAuthenticationForm';

const Login = () => {
  const [displayMFAForm, setDisplayMFAForm] = useState(false);
  const [userLockedOut, setUserLockedOut] = useState(false);
  const [accessCodeErrorMessage, setAccessCodeErrorMessage] = useState(false);
  const [showContactITSupportLink, setShowContactITSupportLink] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { dispatch } = useSecurity();

  useEffect(() => {
    // Session storage is not updated immediately so need to ensure is purged on mounting
    sessionStorage.removeItem('username');
    sessionStorage.removeItem('reg');
    sessionStorage.removeItem('type');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('company');
    sessionStorage.removeItem('companyid');
    sessionStorage.removeItem('name');
    sessionStorage.removeItem('role');
    sessionStorage.removeItem('trader');
    sessionStorage.removeItem('lsp');
    sessionStorage.removeItem('wlp');
    sessionStorage.removeItem('admin');
    sessionStorage.removeItem('fullName');
    sessionStorage.removeItem('department');
    sessionStorage.removeItem('lastLoggedIn');
    sessionStorage.removeItem('duty');
  }, []);

  const handleUserLoginSuccess = (data) => {
    sessionStorage.setItem('token', data.token);
    sessionStorage.setItem('company', data.company);
    sessionStorage.setItem('companyid', data.companyid);
    sessionStorage.setItem('name', data.name);
    sessionStorage.setItem('reg', data.reg);
    sessionStorage.setItem('type', data.type);
    sessionStorage.setItem('fullName', data.fullName);
    sessionStorage.setItem('role', data.role);
    sessionStorage.setItem('department', data.department);
    sessionStorage.setItem('admin', data.admin);
    sessionStorage.setItem('trader', data.trader);
    sessionStorage.setItem('lsp', data.lsp);
    sessionStorage.setItem('lsp', data.wlp);
    sessionStorage.setItem('lastLoggedIn', data.lastLoginIn);
    sessionStorage.setItem('duty', data.duty);

    dispatch({ type: 'login', detail: data });
    // Redirect to page user originally attempted to access, if set.
    if (location.state && location.state.from) {
      navigate(location.state.from);
    } else {
      navigate(!data.reg ? '/userProfile' : '/main');
    }
  };

  return displayMFAForm ? (
    <MultiFactorAuthentication
      handleUserLoginSuccess={handleUserLoginSuccess}
      setDisplayMFAForm={setDisplayMFAForm}
      setUserLockedOut={setUserLockedOut}
      setAccessCodeErrorMessage={setAccessCodeErrorMessage}
      setShowContactITSupportLink={setShowContactITSupportLink}
    />
  ) : (
    <LoginForm
      handleUserLoginSuccess={handleUserLoginSuccess}
      setDisplayMFAForm={setDisplayMFAForm}
      userLockedOut={userLockedOut}
      accessCodeErrorMessage={accessCodeErrorMessage}
      showContactITSupportLink={showContactITSupportLink}
      setShowContactITSupportLink={setShowContactITSupportLink}
    />
  );
};

export default Login;
